(function(angular, _) {
    /**
     * @ngdoc controller
     * @name MonadSelectorListController
     * @description Controller responsible for handling the monad selector list
     */
    class MonadSelectorListController {
        static get $inject() {
            return ['$element', '$injector'];
        }

        constructor($element, $injector) {
            this.$element = $element;
            this.$injector = $injector;
            this.$timeout = $injector.get('$timeout');

            /**
             * Map containing the watchers defined in the controller
             * @type {Object}
             */
            this.watchers = {};

            /**
             * Map containing currently running timeouts
             * @type {Object}
             */
            this.timeouts = {};
        }

        $onDestroy() {
            _.forEach(this.watchers, (watcher) => watcher());
            _.forEach(this.timeouts, (timeout) => this.$timeout.cancel(timeout));
        }

        /**
         * @ngdoc controller
         * @name MonadSelectorListController#isDisabled
         * @description Checks if a monad is selectable
         * @param {Object} monad The monad to check
         * @returns {boolean}
         */
        isDisabled(monad) {
            return _.isFunction(this.isMonadDisabled)
                ? this.isMonadDisabled({monad})
                : false;
        }

        /**
         * @ngdoc controller
         * @name MonadSelectorListController#getTooltip
         * @description Retrieves the tooltip to be displayed for a specific monad
         * @param {Object} monad The monad to retrieve the tooltip for
         * @returns {string}
         */
        getTooltip(monad) {
            return _.isFunction(this.getMonadTooltip)
                ? this.getMonadTooltip({monad})
                : '';
        }

        /**
         * @ngdoc controller
         * @name MonadSelectorListController#isEmptyResultView
         * @description Checks if the monad selector has items to show
         * @returns {bool}
         */
        isEmptyResultView() {
            return !(_.isArray(this.listItems) && _.size(this.listItems));
        }

        /**
         * @ngdoc controller
         * @name MonadSelectorListController#helpClick
         * @description Delegates the click event on a monad item help
         * @param {Object} $event The click event
         * @param {Object} monad The monad to retrieve the help content for
         * @returns {MonadSelectorListController}
         */
        helpClick($event, monad) {
            if (_.isFunction(this.onHelpClick)) {
                this.onHelpClick({$event, monad});
            }

            return this;
        }
    }

    angular.module('wtApp.wtSelector').component('monadSelectorList', {
        controller: MonadSelectorListController,
        templateUrl: 'src/components/monad-selector-list/monad-selector-list.component.html',
        bindings: {
            /**
             * List of items to display and group
             * @type {Array<Object>}
             */
            listItems: '<',

            /**
             * Callback that gets triggered on help click
             * Provides two arguments: {monad, $event}
             * @type {Function}
             */
            onHelpClick: '&',

            /**
             * Callback to check if a monad is disabled
             * Provides one argument: {monad}
             * @type {Function}
             */
            isMonadDisabled: '&?',

            /**
             * Callback to retrieve the monad tooltip
             * Provides one argument: {monad}
             * @type {Function}
             */
            getMonadTooltip: '&?',

            /**
             * Is the current selector list used to render the entire list of monads or just a subset of monads (group)
             * @type {boolean}
             */
            isList: '<?'
        }
    });
})(window.angular, window._);
